module.exports = __webpack_public_path__ + "img/21.aab48fe9.jpg";